"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configsValidationService = void 0;
var ConfigsValidationService_1 = require("./implementation/ConfigsValidationService");
exports.configsValidationService = new ConfigsValidationService_1.ConfigsValidationService();
//# sourceMappingURL=index.js.map